import { PathObj } from "../types/wptypes";
import { Color } from "../types/sstypes";

//sunny: adapted from canvg

export class Point {
    constructor(public x, public y) {
    }
    angleTo(p) {
        return Math.atan2(p.y - this.y, p.x - this.x);
    }

    applyTransform(v) {
        var xp = this.x * v[0] + this.y * v[2] + v[4];
        var yp = this.x * v[1] + this.y * v[3] + v[5];
        this.x = xp;
        this.y = yp;
    }
}

export class BoundingBox {
    x1 = Number.NaN;
    y1 = Number.NaN;
    x2 = Number.NaN;
    y2 = Number.NaN;
    constructor(x1?, y1?, x2?, y2?) {
        this.addPoint(x1, y1);
        this.addPoint(x2, y2);
    }

    x() { return this.x1; }
    y() { return this.y1; }
    width() { return this.x2 - this.x1; }
    height() { return this.y2 - this.y1; }

    addPoint(x, y) {
        if (x != null) {
            if (isNaN(this.x1) || isNaN(this.x2)) {
                this.x1 = x;
                this.x2 = x;
            }
            if (x < this.x1) this.x1 = x;
            if (x > this.x2) this.x2 = x;
        }

        if (y != null) {
            if (isNaN(this.y1) || isNaN(this.y2)) {
                this.y1 = y;
                this.y2 = y;
            }
            if (y < this.y1) this.y1 = y;
            if (y > this.y2) this.y2 = y;
        }
    }
    addX(x) { this.addPoint(x, null); }
    addY(y) { this.addPoint(null, y); }

    addBoundingBox(bb) {
        this.addPoint(bb.x1, bb.y1);
        this.addPoint(bb.x2, bb.y2);
    }

    addQuadraticCurve(p0x, p0y, p1x, p1y, p2x, p2y) {
        var cp1x = p0x + 2 / 3 * (p1x - p0x); // CP1 = QP0 + 2/3 *(QP1-QP0)
        var cp1y = p0y + 2 / 3 * (p1y - p0y); // CP1 = QP0 + 2/3 *(QP1-QP0)
        var cp2x = cp1x + 1 / 3 * (p2x - p0x); // CP2 = CP1 + 1/3 *(QP2-QP0)
        var cp2y = cp1y + 1 / 3 * (p2y - p0y); // CP2 = CP1 + 1/3 *(QP2-QP0)
        this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
    }

    addBezierCurve(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
        // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
        var p0 = [p0x, p0y],
            p1 = [p1x, p1y],
            p2 = [p2x, p2y],
            p3 = [p3x, p3y];
        this.addPoint(p0[0], p0[1]);
        this.addPoint(p3[0], p3[1]);

        for (var i = 0; i <= 1; i++) {
            var f = function (t) {
                return Math.pow(1 - t, 3) * p0[i] +
                    3 * Math.pow(1 - t, 2) * t * p1[i] +
                    3 * (1 - t) * Math.pow(t, 2) * p2[i] +
                    Math.pow(t, 3) * p3[i];
            }

            var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            var c = 3 * p1[i] - 3 * p0[i];

            if (a == 0) {
                if (b == 0) continue;
                var t = -c / b;
                if (0 < t && t < 1) {
                    if (i == 0) this.addX(f(t));
                    if (i == 1) this.addY(f(t));
                }
                continue;
            }

            var b2ac = Math.pow(b, 2) - 4 * c * a;
            if (b2ac < 0) continue;
            var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
            if (0 < t1 && t1 < 1) {
                if (i == 0) this.addX(f(t1));
                if (i == 1) this.addY(f(t1));
            }
            var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
            if (0 < t2 && t2 < 1) {
                if (i == 0) this.addX(f(t2));
                if (i == 1) this.addY(f(t2));
            }
        }
    }

    isPointInBox(x, y) {
        return (this.x1 <= x && x <= this.x2 && this.y1 <= y && y <= this.y2);
    }
}
export class PathParser {
    tokens: []
    points: Point[]
    angles: number[]
    i: number
    command: string
    previousCommand: string
    start: Point
    control: Point
    current: Point

    reset(d) {
        this.i = -1;
        this.command = '';
        this.previousCommand = '';
        this.start = new Point(0, 0);
        this.control = new Point(0, 0);
        this.current = new Point(0, 0);
        this.points = [];
        this.angles = [];

        this.tokens = d.split(' ')
    }

    isEnd() {
        return this.i >= this.tokens.length - 1;
    }

    isCommandOrEnd() {
        if (this.isEnd()) return true;
        return (this.tokens[this.i + 1] as string).match(/^[A-Za-z]$/) != null;
    }

    isRelativeCommand() {
        switch (this.command) {
            case 'm':
            case 'l':
            case 'h':
            case 'v':
            case 'c':
            case 's':
            case 'q':
            case 't':
            case 'a':
            case 'z':
                return true;
        }
        return false;
    }

    getToken() {
        this.i++;
        return this.tokens[this.i];
    }

    getScalar() {
        return parseFloat(this.getToken());
    }

    nextCommand() {
        this.previousCommand = this.command;
        this.command = this.getToken();
    }

    getPoint() {
        var p = new Point(this.getScalar(), this.getScalar());
        return this.makeAbsolute(p);
    }

    getAsControlPoint() {
        var p = this.getPoint();
        this.control = p;
        return p;
    }

    getAsCurrentPoint() {
        var p = this.getPoint();
        this.current = p;
        return p;
    }

    getReflectedControlPoint() {
        if (this.previousCommand.toLowerCase() != 'c' &&
            this.previousCommand.toLowerCase() != 's' &&
            this.previousCommand.toLowerCase() != 'q' &&
            this.previousCommand.toLowerCase() != 't') {
            return this.current;
        }

        // reflect point
        var p = new Point(2 * this.current.x - this.control.x, 2 * this.current.y - this.control.y);
        return p;
    }

    makeAbsolute(p) {
        if (this.isRelativeCommand()) {
            p.x += this.current.x;
            p.y += this.current.y;
        }
        return p;
    }

    addMarker(p, from?, priorTo?) {
        // if the last angle isn't filled in because we didn't have this point yet ...
        if (priorTo != null && this.angles.length > 0 && this.angles[this.angles.length - 1] == null) {
            this.angles[this.angles.length - 1] = this.points[this.points.length - 1].angleTo(priorTo);
        }
        this.addMarkerAngle(p, from == null ? null : from.angleTo(p));
    }

    addMarkerAngle(p, a) {
        this.points.push(p);
        this.angles.push(a);
    }

    getMarkerPoints() { return this.points; }
    getMarkerAngles() {
        for (var i = 0; i < this.angles.length; i++) {
            if (this.angles[i] == null) {
                for (var j = i + 1; j < this.angles.length; j++) {
                    if (this.angles[j] != null) {
                        this.angles[i] = this.angles[j];
                        break;
                    }
                }
            }
        }
        return this.angles;
    }
}

export class PathPainter {
    private static pathParser: PathParser = new PathParser()
    public static paintPath(ctx: CanvasRenderingContext2D, obj: PathObj) {
        var pp = PathPainter.pathParser;
        pp.reset(obj.v);
        var cntrl, p1, r
        var bb = new BoundingBox();
        if (ctx != null) ctx.beginPath();
        while (!pp.isEnd()) {
            pp.nextCommand();
            switch (pp.command) {
                case 'M':
                case 'm':
                    var p = pp.getAsCurrentPoint();
                    pp.addMarker(p);
                    bb.addPoint(p.x, p.y);
                    if (ctx != null) ctx.moveTo(p.x, p.y);
                    pp.start = pp.current;
                    while (!pp.isCommandOrEnd()) {
                        var p = pp.getAsCurrentPoint();
                        pp.addMarker(p, pp.start);
                        bb.addPoint(p.x, p.y);
                        if (ctx != null) ctx.lineTo(p.x, p.y);
                    }
                    break;
                case 'L':
                case 'l':
                    while (!pp.isCommandOrEnd()) {
                        var c = pp.current;
                        var p = pp.getAsCurrentPoint();
                        pp.addMarker(p, c);
                        bb.addPoint(p.x, p.y);
                        if (ctx != null) ctx.lineTo(p.x, p.y);
                    }
                    break;
                case 'H':
                case 'h':
                    while (!pp.isCommandOrEnd()) {
                        var newP = new Point((pp.isRelativeCommand() ? pp.current.x : 0) + pp.getScalar(), pp.current.y);
                        pp.addMarker(newP, pp.current);
                        pp.current = newP;
                        bb.addPoint(pp.current.x, pp.current.y);
                        if (ctx != null) ctx.lineTo(pp.current.x, pp.current.y);
                    }
                    break;
                case 'V':
                case 'v':
                    while (!pp.isCommandOrEnd()) {
                        var newP = new Point(pp.current.x, (pp.isRelativeCommand() ? pp.current.y : 0) + pp.getScalar());
                        pp.addMarker(newP, pp.current);
                        pp.current = newP;
                        bb.addPoint(pp.current.x, pp.current.y);
                        if (ctx != null) ctx.lineTo(pp.current.x, pp.current.y);
                    }
                    break;
                case 'C':
                case 'c':
                    while (!pp.isCommandOrEnd()) {
                        var curr = pp.current;
                        var p1 = pp.getPoint();
                        var cntrl = pp.getAsControlPoint();
                        var cp = pp.getAsCurrentPoint();
                        pp.addMarker(cp, cntrl, p1);
                        bb.addBezierCurve(curr.x, curr.y, p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
                        if (ctx != null) ctx.bezierCurveTo(p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
                    }
                    break;
                case 'S':
                case 's':
                    while (!pp.isCommandOrEnd()) {
                        var curr = pp.current;
                        p1 = pp.getReflectedControlPoint();
                        var cntrl = pp.getAsControlPoint();
                        var cp = pp.getAsCurrentPoint();
                        pp.addMarker(cp, cntrl, p1);
                        bb.addBezierCurve(curr.x, curr.y, p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
                        if (ctx != null) ctx.bezierCurveTo(p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
                    }
                    break;
                case 'Q':
                case 'q':
                    while (!pp.isCommandOrEnd()) {
                        var curr = pp.current;
                        var cntrl = pp.getAsControlPoint();
                        var cp = pp.getAsCurrentPoint();
                        pp.addMarker(cp, cntrl, cntrl);
                        bb.addQuadraticCurve(curr.x, curr.y, cntrl.x, cntrl.y, cp.x, cp.y);
                        if (ctx != null) ctx.quadraticCurveTo(cntrl.x, cntrl.y, cp.x, cp.y);
                    }
                    break;
                case 'T':
                case 't':
                    while (!pp.isCommandOrEnd()) {
                        var curr = pp.current;
                        cntrl = pp.getReflectedControlPoint();
                        pp.control = cntrl;
                        var cp = pp.getAsCurrentPoint();
                        pp.addMarker(cp, cntrl, cntrl);
                        bb.addQuadraticCurve(curr.x, curr.y, cntrl.x, cntrl.y, cp.x, cp.y);
                        if (ctx != null) ctx.quadraticCurveTo(cntrl.x, cntrl.y, cp.x, cp.y);
                    }
                    break;
                case 'A':
                case 'a':
                    while (!pp.isCommandOrEnd()) {
                        var curr = pp.current;
                        var rx = pp.getScalar();
                        var ry = pp.getScalar();
                        var xAxisRotation = pp.getScalar() * (Math.PI / 180.0);
                        var largeArcFlag = pp.getScalar() ? 1 : 0;
                        var sweepFlag = pp.getScalar() ? 1 : 0;
                        var cp = pp.getAsCurrentPoint();

                        // Conversion from endpoint to center parameterization
                        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
                        // x1', y1'
                        var currp = new Point(
                            Math.cos(xAxisRotation) * (curr.x - cp.x) / 2.0 + Math.sin(xAxisRotation) * (curr.y - cp.y) / 2.0, -Math.sin(xAxisRotation) * (curr.x - cp.x) / 2.0 + Math.cos(xAxisRotation) * (curr.y - cp.y) / 2.0
                        );
                        // adjust radii
                        var l = Math.pow(currp.x, 2) / Math.pow(rx, 2) + Math.pow(currp.y, 2) / Math.pow(ry, 2);
                        if (l > 1) {
                            rx *= Math.sqrt(l);
                            ry *= Math.sqrt(l);
                        }
                        // cx', cy'
                        var s = (largeArcFlag == sweepFlag ? -1 : 1) * Math.sqrt(
                            ((Math.pow(rx, 2) * Math.pow(ry, 2)) - (Math.pow(rx, 2) * Math.pow(currp.y, 2)) - (Math.pow(ry, 2) * Math.pow(currp.x, 2))) /
                            (Math.pow(rx, 2) * Math.pow(currp.y, 2) + Math.pow(ry, 2) * Math.pow(currp.x, 2))
                        );
                        if (isNaN(s)) s = 0;
                        var cpp = new Point(s * rx * currp.y / ry, s * -ry * currp.x / rx);
                        // cx, cy
                        var centp = new Point(
                            (curr.x + cp.x) / 2.0 + Math.cos(xAxisRotation) * cpp.x - Math.sin(xAxisRotation) * cpp.y,
                            (curr.y + cp.y) / 2.0 + Math.sin(xAxisRotation) * cpp.x + Math.cos(xAxisRotation) * cpp.y
                        );
                        // vector magnitude
                        var m = function (v) { return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2)); }
                        // ratio between two vectors
                        r = function (u, v) { return (u[0] * v[0] + u[1] * v[1]) / (m(u) * m(v)) }
                        // angle between two vectors
                        var a = function (u, v) { return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(r(u, v)); }
                        // initial angle
                        var a1 = a([1, 0], [(currp.x - cpp.x) / rx, (currp.y - cpp.y) / ry]);
                        // angle delta
                        var u = [(currp.x - cpp.x) / rx, (currp.y - cpp.y) / ry];
                        var v = [(-currp.x - cpp.x) / rx, (-currp.y - cpp.y) / ry];
                        var ad = a(u, v);
                        if (r(u, v) <= -1) ad = Math.PI;
                        if (r(u, v) >= 1) ad = 0;

                        // for markers
                        var dir = 1 - sweepFlag ? 1.0 : -1.0;
                        var ah = a1 + dir * (ad / 2.0);
                        var halfWay = new Point(
                            centp.x + rx * Math.cos(ah),
                            centp.y + ry * Math.sin(ah)
                        );
                        pp.addMarkerAngle(halfWay, ah - dir * Math.PI / 2);
                        pp.addMarkerAngle(cp, ah - dir * Math.PI);

                        bb.addPoint(cp.x, cp.y); // TODO: this is too naive, make it better
                        if (ctx != null && !isNaN(a1) && !isNaN(ad)) {
                            r = rx > ry ? rx : ry;
                            var sx = rx > ry ? 1 : rx / ry;
                            var sy = rx > ry ? ry / rx : 1;

                            ctx.translate(centp.x, centp.y);
                            ctx.rotate(xAxisRotation);
                            ctx.scale(sx, sy);
                            ctx.arc(0, 0, r, a1, a1 + ad, (1 - sweepFlag) ? true : false);
                            ctx.scale(1 / sx, 1 / sy);
                            ctx.rotate(-xAxisRotation);
                            ctx.translate(-centp.x, -centp.y);
                        }
                    }
                    break;
                case 'Z':
                case 'z':
                    if (ctx != null) {
                        // only close path if it is not a straight line
                        if (bb.x1 !== bb.x2 && bb.y1 !== bb.y2) {
                            ctx.closePath();
                        }
                    }
                    pp.current = pp.start;
            }
        }

        return bb;
    }
}

interface LastPoint {
    x: number
    y: number
}

export let convertSVGPathToPath = (lPath: CanvasRenderingContext2D, svgPath: string): void => { //svg path convert Path
    let lastPoint: LastPoint = Object.create(null);
    let pathArr: string[] = svgPath.split(' ');
    for (let i = 0; i < pathArr.length; i++) {
        switch (pathArr[i]) {
            case 'm':
            case 'M': {
                lastPoint.x = Number.parseFloat(pathArr[i + 1])
                lastPoint.y = Number.parseFloat(pathArr[i + 2])
                lPath.moveTo(Number.parseFloat(pathArr[i + 1]), Number.parseFloat(pathArr[i + 2]));
                i += 2;
            }
                break;
            case 'l':
            case 'L': {
                lastPoint.x = Number.parseFloat(pathArr[i + 1])
                lastPoint.y = Number.parseFloat(pathArr[i + 2])
                lPath.lineTo(Number.parseFloat(pathArr[i + 1]), Number.parseFloat(pathArr[i + 2]));
                i += 2;
            }
                break;
            case 'h':
            case 'H': {//基于上个坐标在水平方向上划线，因此y轴不变
                lastPoint.x = Number.parseFloat(pathArr[i + 1])
                lPath.lineTo(lastPoint.x, lastPoint.y);
                i += 1;
            }
                break;
            case 'v':
            case 'V': {//基于上个坐标在水平方向上划线，因此x轴不变
                lastPoint.y = Number.parseFloat(pathArr[i + 1])
                lPath.lineTo(lastPoint.x, lastPoint.y);
                i += 1;
            }
                break;
            case 'c':
            case 'C': {//3次贝塞尔曲线
                lastPoint.x = Number.parseFloat(pathArr[i + 5])
                lastPoint.y = Number.parseFloat(pathArr[i + 6])
                lPath.bezierCurveTo(Number.parseFloat(pathArr[i + 1]),
                    Number.parseFloat(pathArr[i + 2]),
                    Number.parseFloat(pathArr[i + 3]),
                    Number.parseFloat(pathArr[i + 4]),
                    Number.parseFloat(pathArr[i + 5]),
                    Number.parseFloat(pathArr[i + 6]));
                i += 6;

            }
                break;
            case 's':
            case 'S': {//一般S会跟在C或是S命令后面使用，用前一个点做起始控制点
                lPath.bezierCurveTo(lastPoint.x, lastPoint.y,
                    Number.parseFloat(pathArr[i + 1]),
                    Number.parseFloat(pathArr[i + 2]),
                    Number.parseFloat(pathArr[i + 3]),
                    Number.parseFloat(pathArr[i + 4]));
                lastPoint.x = Number.parseFloat(pathArr[i + 3])
                lastPoint.y = Number.parseFloat(pathArr[i + 4])
                i += 4;
            }
                break;
            case 'q':
            case 'Q': {//二次贝塞尔曲线
                lastPoint.x = Number.parseFloat(pathArr[i + 3])
                lastPoint.y = Number.parseFloat(pathArr[i + 4])
                lPath.quadraticCurveTo(Number.parseFloat(pathArr[i + 1]),
                    Number.parseFloat(pathArr[i + 2]),
                    Number.parseFloat(pathArr[i + 3]),
                    Number.parseFloat(pathArr[i + 4]));
                i += 4;
            }
                break;
            case 't':
            case 'T': {//T命令会跟在Q后面使用，用Q的结束点做起始点
                lPath.quadraticCurveTo(lastPoint.x,
                    lastPoint.y,
                    Number.parseFloat(pathArr[i + 1]),
                    Number.parseFloat(pathArr[i + 2]));
                lastPoint.x = Number.parseFloat(pathArr[i + 1])
                lastPoint.y = Number.parseFloat(pathArr[i + 2])
                i += 2;
            }
                break;
            case 'a':
            case 'A': {//画弧
            }
                break;
            case 'z':
            case 'Z': {//结束
                lPath.closePath()
            }
                break;
        }
    }
}

export let paintPathGradient1 = (g: CanvasRenderingContext2D, obj: any, rect: number[], pathValue: string, drawType?: string) => { //渐变色------if pathType 6
    let colors = obj.paintInfo ? obj.paintInfo.colors : obj.colors,
        intervals = obj.paintInfo ? obj.paintInfo.intervals : obj.intervals,
        gradientType = obj.paintInfo ? obj.paintInfo.gradientType : obj.gradientType,
        textureIndex = obj.paintInfo ? obj.paintInfo.textureIndex : obj.textureIndex,
        x = rect[0],
        y = rect[1],
        w = rect[2],
        h = rect[3],
        gradient: CanvasGradient,
        gradientArr: CanvasGradient[] = []
    if (drawType != 'stroke') {
        g.save()
        g.beginPath()
        convertSVGPathToPath(g, pathValue)
        g.clip()
    }
    if (obj.ctm) {
        g.transform(obj.ctm[0], obj.ctm[1], obj.ctm[2], obj.ctm[3], obj.ctm[4], obj.ctm[5])
    }
    if (gradientType == 0) { //水平
        g.beginPath()
        switch (textureIndex) {
            case 0:
                gradient = g.createLinearGradient(0, y, 0, y + h)
                gradientArr.push(gradient)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.rect(x, y, w, h)
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.rect(x, y, w, h)
                    g.stroke()
                }
                break;
            case 1:
                gradient = g.createLinearGradient(0, y + h, 0, y)
                gradientArr.push(gradient)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.rect(x, y, w, h)
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.rect(x, y, w, h)
                    g.stroke()
                }
                break;
            case 2:
                let gradient2: CanvasGradient = g.createLinearGradient(0, y + h, 0, y + h / 2)
                gradient = g.createLinearGradient(0, y, 0, y + h / 2)
                gradientArr.push(gradient, gradient2)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.rect(x, y, w, h / 2)
                    g.fill()
                    g.beginPath()
                    g.fillStyle = gradient2
                    g.rect(x, y + h / 2, w, h / 2)
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.rect(x, y, w, h / 2)
                    g.stroke()
                    g.beginPath()
                    g.strokeStyle = gradient2
                    g.rect(x, y + h / 2, w, h / 2)
                    g.stroke()
                }
                break;
            case 3:
                let gradient3: CanvasGradient = g.createLinearGradient(0, y + h / 2, 0, y + h)
                gradient = g.createLinearGradient(0, y + h / 2, 0, y)
                gradientArr.push(gradient, gradient3)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.rect(x, y, w, h / 2)
                    g.fill()
                    g.beginPath()
                    g.fillStyle = gradient3
                    g.rect(x, y + h / 2, w, h / 2)
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.rect(x, y, w, h / 2)
                    g.stroke()
                    g.beginPath()
                    g.strokeStyle = gradient3
                    g.rect(x, y + h / 2, w, h / 2)
                    g.stroke()
                }
                break;
        }
    } else if (gradientType == 1) { //垂直
        g.beginPath()
        switch (textureIndex) {
            case 0:
                gradient = g.createLinearGradient(x, 0, x + w, 0)
                gradientArr.push(gradient)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.rect(x, y, w, h)
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.rect(x, y, w, h)
                    g.stroke()
                }
                break;
            case 1:
                gradient = g.createLinearGradient(x + w, 0, x, 0)
                gradientArr.push(gradient)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.rect(x, y, w, h)
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.rect(x, y, w, h)
                    g.stroke()
                }
                break;
            case 2:
                let gradient2: CanvasGradient = g.createLinearGradient(x + w, 0, x + w / 2, 0)
                gradient = g.createLinearGradient(x, 0, x + w / 2, 0)
                gradientArr.push(gradient, gradient2)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.rect(x, y, w / 2, h)
                    g.fill()
                    g.beginPath()
                    g.fillStyle = gradient2
                    g.rect(x + w / 2, y, w / 2, h)
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.rect(x, y, w / 2, h)
                    g.stroke()
                    g.beginPath()
                    g.strokeStyle = gradient2
                    g.rect(x + w / 2, y, w / 2, h)
                    g.stroke()
                }
                break;
            case 3:
                let gradient3: CanvasGradient = g.createLinearGradient(x + w / 2, 0, x + w, 0)
                gradient = g.createLinearGradient(x + w / 2, 0, x, 0)
                gradientArr.push(gradient, gradient3)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.rect(x, y, w / 2, h)
                    g.fill()
                    g.beginPath()
                    g.fillStyle = gradient3
                    g.rect(x + w / 2, y, w / 2, h)
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.rect(x, y, w / 2, h)
                    g.stroke()
                    g.beginPath()
                    g.strokeStyle = gradient3
                    g.rect(x + w / 2, y, w / 2, h)
                    g.stroke()
                }
                break;
        }
    } else if (gradientType == 2) { //斜上
        g.beginPath()
        switch (textureIndex) {
            case 0:
                let a: number = Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)), //勾股
                    b: number = w * h / a, //直角三角形斜边的高等于两直角边的乘积除以斜边
                    d: number = Math.sqrt(Math.pow(h, 2) - Math.pow(b, 2)),
                    e: number = a - 2 * d,
                    y_1: number = y - d,
                    x_1: number = x + Math.sqrt(Math.abs(Math.pow(e, 2) - Math.pow(d, 2)))
                gradient = g.createLinearGradient(x_1, y_1, x + w, y + h)
                gradientArr.push(gradient)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fillRect(x, y, w, h)
                } else {
                    g.strokeStyle = gradient
                    g.strokeRect(x, y, w, h)
                }
                break;
            case 1:
                let a_: number = Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)), //勾股
                    b_: number = w * h / a_, //直角三角形斜边的高等于两直角边的乘积除以斜边
                    d_: number = Math.sqrt(Math.pow(h, 2) - Math.pow(b_, 2)),
                    e_: number = a_ - 2 * d_,
                    y_1_: number = y - d_,
                    x_1_: number = x + Math.sqrt(Math.abs(Math.pow(e_, 2) - Math.pow(d_, 2)))
                gradient = g.createLinearGradient(x + w, y + h, x_1_, y_1_)
                gradientArr.push(gradient)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fillRect(x, y, w, h)
                } else {
                    g.strokeStyle = gradient
                    g.strokeRect(x, y, w, h)
                }
                break;
            case 2:
                let s1: number = Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)), //勾股
                    sh: number = w * h / s1, //直角三角形斜边的高等于两直角边的乘积除以斜边
                    sts: number = Math.sqrt(Math.pow(w, 2) - Math.pow(sh, 2)),
                    sh2 = sh * sts / w,
                    sts2 = Math.sqrt(Math.pow(sts, 2) - Math.pow(sh2, 2)),
                    x1 = x + sts2,
                    y1 = y + (h - sh2),
                    x2 = x + (w - sts2),
                    y2 = y + sh2,
                    gradient2 = g.createLinearGradient(x, y, x2, y2)
                gradient = g.createLinearGradient(x + w, y + h, x1, y1)
                gradientArr.push(gradient, gradient2)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.beginPath()
                    g.moveTo(x, y + h)
                    g.lineTo(x + w, y + h)
                    g.lineTo(x + w, y)
                    g.closePath()
                    g.fill()
                    g.fillStyle = gradient2
                    g.beginPath()
                    g.moveTo(x + w, y)
                    g.lineTo(x, y)
                    g.lineTo(x, y + h)
                    g.closePath()
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.beginPath()
                    g.moveTo(x, y + h)
                    g.lineTo(x + w, y + h)
                    g.lineTo(x + w, y)
                    g.closePath()
                    g.stroke()
                    g.strokeStyle = gradient2
                    g.beginPath()
                    g.moveTo(x + w, y)
                    g.lineTo(x, y)
                    g.lineTo(x, y + h)
                    g.closePath()
                    g.stroke()
                }
                break;
            case 3:
                let s1_: number = Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)), //勾股
                    sh_: number = w * h / s1_, //直角三角形斜边的高等于两直角边的乘积除以斜边
                    sts_: number = Math.sqrt(Math.pow(w, 2) - Math.pow(sh_, 2)),
                    sh2_ = sh_ * sts_ / w,
                    sts2_ = Math.sqrt(Math.pow(sts_, 2) - Math.pow(sh2_, 2)),
                    x1_ = x + sts2_,
                    y1_ = y + (h - sh2_),
                    x2_ = x + (w - sts2_),
                    y2_ = y + sh2_,
                    gradient2_ = g.createLinearGradient(x2_, y2_, x, y)
                gradient = g.createLinearGradient(x1_, y1_, x + w, y + h)
                gradientArr.push(gradient, gradient2_)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.beginPath()
                    g.moveTo(x, y + h)
                    g.lineTo(x + w, y + h)
                    g.lineTo(x + w, y)
                    g.closePath()
                    g.fill()
                    g.fillStyle = gradient2_
                    g.beginPath()
                    g.moveTo(x + w, y)
                    g.lineTo(x, y)
                    g.lineTo(x, y + h)
                    g.closePath()
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.beginPath()
                    g.moveTo(x, y + h)
                    g.lineTo(x + w, y + h)
                    g.lineTo(x + w, y)
                    g.closePath()
                    g.stroke()
                    g.strokeStyle = gradient2_
                    g.beginPath()
                    g.moveTo(x + w, y)
                    g.lineTo(x, y)
                    g.lineTo(x, y + h)
                    g.closePath()
                    g.stroke()
                }
                break;
        }
    } else if (gradientType == 3) { //斜下
        switch (textureIndex) {
            case 0:
                let a: number = Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)), //勾股
                    b: number = w * h / a, //直角三角形斜边的高等于两直角边的乘积除以斜边
                    d: number = Math.sqrt(Math.pow(h, 2) - Math.pow(b, 2)),
                    e: number = a - 2 * d,
                    y_1: number = y - d,
                    x_1: number = x + (w - Math.sqrt(Math.abs(Math.pow(e, 2) - Math.pow(d, 2))))
                gradient = g.createLinearGradient(x_1, y_1, x, y + h)
                gradientArr.push(gradient)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fillRect(x, y, w, h)
                } else {
                    g.strokeStyle = gradient
                    g.strokeRect(x, y, w, h)
                }
                break;
            case 1:
                let a_: number = Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)), //勾股
                    b_: number = w * h / a_, //直角三角形斜边的高等于两直角边的乘积除以斜边
                    d_: number = Math.sqrt(Math.pow(h, 2) - Math.pow(b_, 2)),
                    e_: number = a_ - 2 * d_,
                    y_1_: number = y - d_,
                    x_1_: number = x + (w - Math.sqrt(Math.abs(Math.pow(e_, 2) - Math.pow(d_, 2))))
                gradient = g.createLinearGradient(x, y + h, x_1_, y_1_)
                gradientArr.push(gradient)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fillRect(x, y, w, h)
                } else {
                    g.strokeStyle = gradient
                    g.strokeRect(x, y, w, h)
                }
                break;
            case 2:
                let s1: number = Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)), //勾股
                    sh: number = w * h / s1, //直角三角形斜边的高等于两直角边的乘积除以斜边
                    sts: number = Math.sqrt(Math.pow(w, 2) - Math.pow(sh, 2)),
                    sh2 = sh * sts / w,
                    sts2 = Math.sqrt(Math.pow(sts, 2) - Math.pow(sh2, 2)),
                    x1 = x + (w - sts2),
                    y1 = y + (h - sh2),
                    x2 = x + sts2,
                    y2 = y + sh2,
                    gradient2 = g.createLinearGradient(x + w, y, x2, y2)
                gradient = g.createLinearGradient(x, y + h, x1, y1)
                gradientArr.push(gradient, gradient2)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.beginPath()
                    g.moveTo(x + w, y + h)
                    g.lineTo(x, y + h)
                    g.lineTo(x, y)
                    g.closePath()
                    g.fill()
                    g.fillStyle = gradient2
                    g.beginPath()
                    g.moveTo(x, y)
                    g.lineTo(x + w, y)
                    g.lineTo(x + w, y + h)
                    g.closePath()
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.beginPath()
                    g.moveTo(x + w, y + h)
                    g.lineTo(x, y + h)
                    g.lineTo(x, y)
                    g.closePath()
                    g.stroke()
                    g.strokeStyle = gradient2
                    g.beginPath()
                    g.moveTo(x, y)
                    g.lineTo(x + w, y)
                    g.lineTo(x + w, y + h)
                    g.closePath()
                    g.stroke()
                }
                break;
            case 3:
                let s1_: number = Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)), //勾股
                    sh_: number = w * h / s1_, //直角三角形斜边的高等于两直角边的乘积除以斜边
                    sts_: number = Math.sqrt(Math.pow(w, 2) - Math.pow(sh_, 2)),
                    sh2_ = sh_ * sts_ / w,
                    sts2_ = Math.sqrt(Math.pow(sts_, 2) - Math.pow(sh2_, 2)),
                    x1_ = x + (w - sts2_),
                    y1_ = y + (h - sh2_),
                    x2_ = x + sts2_,
                    y2_ = y + sh2_,
                    gradient2_ = g.createLinearGradient(x2_, y2_, x + w, y)
                gradient = g.createLinearGradient(x1_, y1_, x, y + h)
                gradientArr.push(gradient, gradient2_)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.beginPath()
                    g.moveTo(x + w, y + h)
                    g.lineTo(x, y + h)
                    g.lineTo(x, y)
                    g.closePath()
                    g.fill()
                    g.fillStyle = gradient2_
                    g.beginPath()
                    g.moveTo(x, y)
                    g.lineTo(x + w, y)
                    g.lineTo(x + w, y + h)
                    g.closePath()
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.beginPath()
                    g.moveTo(x + w, y + h)
                    g.lineTo(x, y + h)
                    g.lineTo(x, y)
                    g.closePath()
                    g.stroke()
                    g.strokeStyle = gradient2_
                    g.beginPath()
                    g.moveTo(x, y)
                    g.lineTo(x + w, y)
                    g.lineTo(x + w, y + h)
                    g.closePath()
                    g.stroke()
                }
                break;
        }
    } else if (gradientType == 4) { //角部辐射
        let gradient2: CanvasGradient
        switch (textureIndex) {
            case 0: //从左上角
                gradient = g.createLinearGradient(0, y, 0, y + h)
                gradient2 = g.createLinearGradient(x, 0, x + w, 0)
                gradientArr.push(gradient, gradient2)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x, y)
                g.lineTo(x + w, y + h)
                g.lineTo(x, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.moveTo(x, y)
                g.lineTo(x + w, y + h)
                g.lineTo(x + w, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }
                break;
            case 1: //从右上角
                gradient = g.createLinearGradient(x + w, 0, x, 0)
                gradient2 = g.createLinearGradient(0, y, 0, y + h)
                gradientArr.push(gradient, gradient2)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x + w, y)
                g.lineTo(x, y + h)
                g.lineTo(x, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w, y)
                g.lineTo(x, y + h)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }
                break;
            case 2: //左下角
                gradient = g.createLinearGradient(0, y + h, 0, y)
                gradient2 = g.createLinearGradient(x, 0, x + w, 0)
                gradientArr.push(gradient, gradient2)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x, y + h)
                g.lineTo(x + w, y)
                g.lineTo(x, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x, y + h)
                g.lineTo(x + w, y)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }
                break;
            case 3: //从右下角
                gradient = g.createLinearGradient(x + w, 0, x, 0)
                gradient2 = g.createLinearGradient(0, y + h, 0, y)
                gradientArr.push(gradient, gradient2)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x + w, y + h)
                g.lineTo(x, y)
                g.lineTo(x, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w, y + h)
                g.lineTo(x, y)
                g.lineTo(x + w, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }
                break;
            case 6: //中心辐射
                let gradient3: CanvasGradient,
                    gradient4: CanvasGradient
                gradient = g.createLinearGradient(x + w / 2, 0, x, 0)
                gradient2 = g.createLinearGradient(0, y + h / 2, 0, y)
                gradient3 = g.createLinearGradient(x + w / 2, 0, x + w, 0)
                gradient4 = g.createLinearGradient(0, y + h / 2, 0, y + h)
                gradientArr.push(gradient, gradient2, gradient3, gradient4)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x, y)
                g.lineTo(x, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x + w, y)
                g.lineTo(x, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x + w, y)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient3
                    g.fill()
                } else {
                    g.strokeStyle = gradient3
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x, y + h)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient4
                    g.fill()
                } else {
                    g.strokeStyle = gradient4
                    g.stroke()
                }
                break;
        }
    } else if (gradientType == 5) { //中心辐射
        let gradient2: CanvasGradient,
            gradient3: CanvasGradient,
            gradient4: CanvasGradient
        switch (textureIndex) {
            case 0:
                gradient = g.createLinearGradient(x + w / 2, 0, x, 0)
                gradient2 = g.createLinearGradient(0, y + h / 2, 0, y)
                gradient3 = g.createLinearGradient(x + w / 2, 0, x + w, 0)
                gradient4 = g.createLinearGradient(0, y + h / 2, 0, y + h)
                gradientArr.push(gradient, gradient2, gradient3, gradient4)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x, y)
                g.lineTo(x, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x + w, y)
                g.lineTo(x, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x + w, y)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient3
                    g.fill()
                } else {
                    g.strokeStyle = gradient3
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x, y + h)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient4
                    g.fill()
                } else {
                    g.strokeStyle = gradient4
                    g.stroke()
                }
                break;
            case 1:
                gradient = g.createLinearGradient(x, 0, x + w / 2, 0)
                gradient2 = g.createLinearGradient(0, y, 0, y + h / 2)
                gradient3 = g.createLinearGradient(x + w, 0, x + w / 2, 0)
                gradient4 = g.createLinearGradient(0, y + h, 0, y + h / 2)
                gradientArr.push(gradient, gradient2, gradient3, gradient4)
                checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x, y)
                g.lineTo(x, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x + w, y)
                g.lineTo(x, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x + w, y)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient3
                    g.fill()
                } else {
                    g.strokeStyle = gradient3
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x, y + h)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient4
                    g.fill()
                } else {
                    g.strokeStyle = gradient4
                    g.stroke()
                }
                break;
        }
    }
    if (drawType != 'stroke') {
        g.restore()
    }
}

export let paintPathGradient2 = (g: CanvasRenderingContext2D, obj: any, rect: number[], pathValue: string, drawType?: string) => { //渐变色------if pathType 8
    let colors = obj.paintInfo ? obj.paintInfo.colors : obj.colors,
        intervals = obj.paintInfo ? obj.paintInfo.intervals : obj.intervals,
        gradientType = obj.paintInfo ? obj.paintInfo.gradientType : obj.gradientType,
        direction = obj.paintInfo ? obj.paintInfo.direction : obj.direction,
        x = rect[0],
        y = rect[1],
        w = rect[2],
        h = rect[3],
        gradient: CanvasGradient,
        gradientArr: CanvasGradient[] = []
    //drawCanvasGradient
    if (drawType != 'stroke') {
        g.save()
        g.beginPath()
        convertSVGPathToPath(g, pathValue)
        g.clip()
    }
    if (obj.ctm) {
        g.transform(obj.ctm[0], obj.ctm[1], obj.ctm[2], obj.ctm[3], obj.ctm[4], obj.ctm[5])
    }

    if (gradientType == 0) { //线形种类
        let angle = obj.paintInfo ? obj.paintInfo.angle : obj.angle,
            p1: number[],
            p2: number[],
            w2: number,
            h2: number
        g.beginPath()
        // 90°和270°特殊处理
        if (angle == 90 || angle == 270) {
            gradient = g.createLinearGradient(0, y, 0, y + h)
            gradientArr.push(gradient)
            checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
            g.translate(x + w / 2, y + h / 2)
            g.rotate((angle - 90) * Math.PI / 180)
            g.translate(-(x + w / 2), -(y + h / 2))
            g.rect(x, y, w, h)
        } else {
            gradient = g.createLinearGradient(x, 0, x + w, 0)
            gradientArr.push(gradient)
            checkWordOrExcelToAddColorStopHandle(colors, intervals, gradientArr)
            g.translate(x + w / 2, y + h / 2)
            g.rotate(angle * Math.PI / 180)
            g.translate(-(x + w / 2), -(y + h / 2))
            p1 = getRotatePosition(w / 2, h / 2, angle % 180)
            p2 = getRotatePosition(w / 2, -h / 2, angle % 180)
            w2 = Math.max(Math.abs(p1[0]), Math.abs(p2[0]), w / 2)
            h2 = Math.max(Math.abs(p1[1]), Math.abs(p2[1]), h / 2)
            g.rect(x + w / 2 - w2, y + h / 2 - h2, 2 * w2, 2 * h2)
        }
        if (drawType != 'stroke') {
            g.fillStyle = gradient
            g.fill()
        } else {
            g.strokeStyle = gradient
            g.stroke()
        }
    } else if (gradientType == 1) { //射线种类
        let r = Math.abs(h > w ? w : h)
        g.beginPath()
        switch (direction) {
            case 4: //从右下角
                gradient = g.createRadialGradient(x + w, y + h, r / 8, x + w, y + h, r)
                break;
            case 5: //从左下角
                gradient = g.createRadialGradient(x, y + h, r / 8, x, y + h, r)
                break;
            case 6: //中心辐射
                gradient = g.createRadialGradient(x + w / 2, y + h / 2, r / 100, x + w / 2, y + h / 2, r)
                break;
            case 7: //从右上角
                gradient = g.createRadialGradient(x + w, y, r / 8, x + w, y, r)
                break;
            case 8: //从左上角
                gradient = g.createRadialGradient(x, y, r / 8, x, y, r)
                break;
        }
        gradientArr.push(gradient)
        addColorStopHandle(colors, intervals, gradientArr)
        g.rect(x, y, w, h)
        if (drawType != 'stroke') {
            g.fillStyle = gradient
            g.fill()
        } else {
            g.strokeStyle = gradient
            g.stroke()
        }
    } else if (gradientType == 2) { //矩形种类
        let gradient2: CanvasGradient
        switch (direction) {
            case 4: //从右下角
                gradient = g.createLinearGradient(x + w, 0, x, 0)
                gradient2 = g.createLinearGradient(0, y + h, 0, y)
                gradientArr.push(gradient, gradient2)
                addColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x + w, y + h)
                g.lineTo(x, y)
                g.lineTo(x, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w, y + h)
                g.lineTo(x, y)
                g.lineTo(x + w, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }
                break;
            case 5: //从左下角
                gradient = g.createLinearGradient(0, y + h, 0, y)
                gradient2 = g.createLinearGradient(x, 0, x + w, 0)
                gradientArr.push(gradient, gradient2)
                addColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x, y + h)
                g.lineTo(x + w, y)
                g.lineTo(x, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x, y + h)
                g.lineTo(x + w, y)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }
                break;
            case 6: //中心辐射
                let gradient3: CanvasGradient,
                    gradient4: CanvasGradient
                gradient = g.createLinearGradient(x + w / 2, 0, x, 0)
                gradient2 = g.createLinearGradient(0, y + h / 2, 0, y)
                gradient3 = g.createLinearGradient(x + w / 2, 0, x + w, 0)
                gradient4 = g.createLinearGradient(0, y + h / 2, 0, y + h)
                gradientArr.push(gradient, gradient2, gradient3, gradient4)
                addColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x, y)
                g.lineTo(x, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x + w, y)
                g.lineTo(x, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x + w, y)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient3
                    g.fill()
                } else {
                    g.strokeStyle = gradient3
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w / 2, y + h / 2)
                g.lineTo(x, y + h)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient4
                    g.fill()
                } else {
                    g.strokeStyle = gradient4
                    g.stroke()
                }
                break;
            case 7: //从右上角
                gradient = g.createLinearGradient(x + w, 0, x, 0)
                gradient2 = g.createLinearGradient(0, y, 0, y + h)
                gradientArr.push(gradient, gradient2)
                addColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x + w, y)
                g.lineTo(x, y + h)
                g.lineTo(x, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x + w, y)
                g.lineTo(x, y + h)
                g.lineTo(x + w, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }
                break;
            case 8: //从左上角
                gradient = g.createLinearGradient(0, y, 0, y + h)
                gradient2 = g.createLinearGradient(x, 0, x + w, 0)
                gradientArr.push(gradient, gradient2)
                addColorStopHandle(colors, intervals, gradientArr)
                g.beginPath()
                g.moveTo(x, y)
                g.lineTo(x + w, y + h)
                g.lineTo(x, y + h)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient
                    g.fill()
                } else {
                    g.strokeStyle = gradient
                    g.stroke()
                }

                g.beginPath()
                g.moveTo(x, y)
                g.lineTo(x + w, y + h)
                g.lineTo(x + w, y)
                g.closePath()
                if (drawType != 'stroke') {
                    g.fillStyle = gradient2
                    g.fill()
                } else {
                    g.strokeStyle = gradient2
                    g.stroke()
                }
                break;
        }
    } else if (gradientType == 3) { //渐变光圈种类
        let r = Math.abs(h > w ? w : h)
        g.beginPath()
        gradient = g.createRadialGradient(x + w / 2, y + h / 2, r / 600, x + w / 2, y + h / 2, r)
        gradientArr.push(gradient)
        addColorStopHandle(colors, intervals, gradientArr)
        g.rect(x, y, w, h)
        if (drawType != 'stroke') {
            g.fillStyle = gradient
            g.fill()
        } else {
            g.strokeStyle = gradient
            g.stroke()
        }
    }
    if (drawType != 'stroke') {
        g.restore()
    }
}

export let getRotatePosition = (x: number, y: number, angle: number): number[] => {
    let result: number[] = new Array()
    result[0] = x * Math.cos(angle * Math.PI / 180) + y * Math.sin(angle * Math.PI / 180)
    result[1] = -x * Math.sin(angle * Math.PI / 180) + y * Math.cos(angle * Math.PI / 180)
    return result
}

export let checkWordOrExcelToAddColorStopHandle = (colors: Color[], intervals: number[], gradientArr: CanvasGradient[]) => { //pathType 6
    if (colors.length > intervals.length) {
        let distance: number = 0
        for (let i = 0; i < colors.length; i++) {
            if (distance > 1) break
            for (let item of gradientArr) {
                item.addColorStop(distance, `rgba(${colors[i].r},${colors[i].g},${colors[i].b},${colors[i].alpha / 255 || 0.01})`)
            }
            distance += Math.round(intervals[i] * 10) / 10
        }
    } else {
        for (let i = 0; i < colors.length; i++) {
            for (let item of gradientArr) {
                item.addColorStop(intervals[i], `rgba(${colors[i].r},${colors[i].g},${colors[i].b},${colors[i].alpha / 255 || 0.01})`)
            }
        }
    }
}

export let addColorStopHandle = (colors: Color[], intervals: number[], gradientArr: CanvasGradient[]) => { //pathType 8
    for (let i = 0; i < colors.length; i++) {
        for (let item of gradientArr) {
            item.addColorStop(intervals[i], `rgba(${colors[i].r},${colors[i].g},${colors[i].b},${colors[i].alpha / 255 || 0.01})`)
        }
    }
}